export default "__VITE_ASSET__DB2ycUMG__"